import { rgbToCIELab, rgbToCss, rgbToHex, rgbToHsl, rgbToHsv, rgbToXyz } from ".";
import { round } from "../utils";
import { InvalidColorError, isValidCmyk } from "../validators";
const validator = (cmyk, converter) => {
    if (!isValidCmyk(cmyk))
        throw new InvalidColorError(cmyk, "CMYK");
    return converter;
};
const toRgb = (cmyk) => {
    const _c = (cmyk.c > 100 ? 100 : cmyk.c < 0 ? 0 : cmyk.c) / 100;
    const _m = (cmyk.m > 100 ? 100 : cmyk.m < 0 ? 0 : cmyk.m) / 100;
    const _y = (cmyk.y > 100 ? 100 : cmyk.m < 0 ? 0 : cmyk.y) / 100;
    const _k = (cmyk.k > 100 ? 100 : cmyk.k < 0 ? 0 : cmyk.k) / 100;
    return {
        r: round(255 * ((1 - _c) * (1 - _k))),
        g: round(255 * ((1 - _m) * (1 - _k))),
        b: round(255 * ((1 - _y) * (1 - _k)))
    };
};
export const cmykToHex = (cmyk) => validator(cmyk, rgbToHex)(toRgb(cmyk));
export const cmykToCss = (cmyk, options) => validator(cmyk, rgbToCss)(toRgb(cmyk), options);
export const cmykToRgb = (cmyk) => validator(cmyk, toRgb)(cmyk);
export const cmykToHsl = (cmyk, options) => validator(cmyk, rgbToHsl)(toRgb(cmyk), options);
export const cmykToHsv = (cmyk, options) => validator(cmyk, rgbToHsv)(toRgb(cmyk), options);
export const cmykToXyz = (cmyk, options) => validator(cmyk, rgbToXyz)(toRgb(cmyk), options);
export const cmykToCIELab = (cmyk, options) => validator(cmyk, rgbToCIELab)(toRgb(cmyk), options);
